export enum ApiOrderType {
	ExpressCheckout = 'bnshop',
	ProxyShopping = 'b4u',
	Shipping = 'shipment',
}

export enum DiscountType {
	FIXED = 'FIXED',
	PERCENTAGE = 'PERCENTAGE',
	WAIVE_SERVICE_FEE = 'WAIVE_SERVICE_FEE',
}

// Get the type of the enum values
export type ApiOrderTypeValue = `${ApiOrderType}`
export type DiscountTypeValue = `${DiscountType}`

export interface ICoupon {
	order_type: ApiOrderTypeValue
	title: string
	code: string
	discount_type: DiscountTypeValue
	coupon_amount: number | null
	percentage_discount: number | null
	start_date: string | null
	expiry_date: string
	is_expire_soon: boolean
	terms: string
	tabs: string[]
}

export interface ICouponTab {
	tab_id: number
	tab_key: string
	translation_key: string
	order: number
	url_postfix: string
	coupon_idx_list: number[]
}

export interface ICouponResponse {
	coupon_list: ICoupon[]
	tabs: ICouponTab[]
}
